import { useEffect } from 'react';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';

import * as Sentry from '@sentry/react';
import type { BrowserOptions } from '@sentry/react';

export { wrapCreateBrowserRouterV6 } from '@sentry/react';

export const sentryReactIntegrations = () => [
  Sentry.reactRouterV6BrowserTracingIntegration({
    useEffect,
    useLocation,
    useNavigationType,
    createRoutesFromChildren,
    matchRoutes,
  }),
];

export const sentryNoiseFilters: Pick<
  BrowserOptions,
  'denyUrls' | 'ignoreErrors'
> = {
  denyUrls: [
    /otBannerSdk/,
    /otSDKStub/,
    /intercom\.io/,
    /browser-extensions:\/\//,
    /chrome-extension:\/\//,
    /moz-extension:\/\//,
  ],
  ignoreErrors: ['Loading CSS chunk', 'Loading chunk', 'ResizeObserver loop'],
};
